<div class="upload-container">
  <label class="upload-label">{{ svgOnly ? 'Icon' : 'Module' }}</label>

  <label [for]="svgOnly ? 'iconUploadSvg' : 'iconUploadImg'" 
         class="upload-box" 
         [class.has-file]="fileName">
    <ng-container *ngIf="fileName; else placeholder">
      <span class="file-name">{{ fileName }}</span>
    </ng-container>

    <ng-template #placeholder>
      <span class="upload-text">
        {{ svgOnly ? 'Choose an Icon or import it here.' : 'Choose a file or drag & drop it here.' }}
      </span>
      <span class="upload-subtext">
        {{ svgOnly ? 'Only vector format supported' : 'JPEG, PNG, up to 50MB.' }}
      </span>
    </ng-template>
  </label>

  <ng-container *ngIf="svgOnly">
    <input
      id="iconUploadSvg"
      type="file"
      accept=".svg"
      (change)="onFileSelected($event)"
      hidden
    />
  </ng-container>

  <ng-container *ngIf="!svgOnly">
    <input
      id="iconUploadImg"
      type="file"
      accept="image/png, image/jpeg"
      (change)="onFileSelected($event)"
      hidden
    />
  </ng-container>
</div>
